import { getInitials } from './string-utils.js';

// Stored stand-ins that aren't real photos (the add-user default user.svg now 404s): show initials instead.
const PLACEHOLDER_AVATAR = /retro|\/user\.svg(?:$|\?)|default-avatar\.png/;

export function hasRealAvatar(url) {
	return !!url && !PLACEHOLDER_AVATAR.test(url);
}

// Same initials as the nav bar avatar; anonymous-room "User #3" becomes "U3".
export function avatarInitials(name) {
	const cleaned = String(name || '')
		.replace(/#/g, '')
		.trim();
	return getInitials(cleaned, globalThis.window?.clientData?.initials_overrides) || '?';
}

// For avatars rendered as HTML strings: an <img data-initials="AB" data-initials-class="..."> that fails
// to load is swapped for the initials circle. Capture phase, since error events don't bubble.
export function installAvatarFallback() {
	document.addEventListener(
		'error',
		(e) => {
			const img = e.target;
			if (!(img instanceof HTMLImageElement) || img.dataset.initials === undefined) return;
			const div = document.createElement('div');
			div.className = img.dataset.initialsClass || 'initials';
			div.textContent = img.dataset.initials;
			img.replaceWith(div);
		},
		true
	);
}
